import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useState, useEffect } from "react";
import Paginat from "@/components/lib/paginat";
import SingleStaffDetailsTable from "@/components/backoffice/all-staff/staff-report/single-staff-table";
import { Button } from "@/components/ui/button";
import { useParams } from "react-router-dom";
import { fetchSingleStaffAllAttendanceReport } from "@/redux/slice/staff-management/staff-attendance";
import { toast } from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "@/hooks/useSearch";
import useAuth from "@/hooks/useAuth";
import MonthYearSelector from "@/components/common/month-year-selector";

function Report() {
  const [monthDate, setMonthDate] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const { user } = useAuth();
  const [firstLoading, setFirstLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [searchText, setSearchText] = useState("");

  const {
    singleStaffLoading,
    singleStaffPagination,
    singleStaffattendanceStatistics,
    singleStaffAttendance,
  } = useSelector((state) => state.staffManage.attendance);

  const effectiveMonthDate =
    monthDate ||
    (() => {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}`;
    })();

  useEffect(() => {
    const fetchData = async () => {
      if (firstLoading) {
        setFirstLoading(true);
      } else {
        setTableLoading(true);
      }
      const res = await dispatch(
        fetchSingleStaffAllAttendanceReport({
          staff_id: id,
          date: effectiveMonthDate,
          page: page,
          limit: perPage,
        })
      );
      if (fetchSingleStaffAllAttendanceReport.fulfilled.match(res)) {
        setFirstLoading(false);
        setTableLoading(false);
      } else if (fetchSingleStaffAllAttendanceReport.rejected.match(res)) {
        setFirstLoading(false);
        setTableLoading(false);
      }
    };
    fetchData();
  }, [id, dispatch, page, perPage, effectiveMonthDate]);

  const searchData = useSearch(
    singleStaffAttendance,
    searchText,
    ["name", "designation"],
    300
  );

  return (
    <TabsContent value="report">
      <div>
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 md:gap-20 items-start lg:items-center mt-5">
          <div className=" w-full grid grid-cols-2 gap-5 md:grid-cols-4 ">
            <div className="bg-cblack3 py-2 px-4 flex gap-5 rounded-md border border-gray-700">
              <div className="space-y-1 text-white">
                <h2>Present</h2>
                <h2 className="text-base font-bold text-cyellow">
                  {singleStaffattendanceStatistics?.present_days || "0"} Days
                </h2>
              </div>
            </div>
            <div className="bg-cblack3 py-2 px-4 flex gap-5 rounded-md border border-gray-700">
              <div className="space-y-1 text-white">
                <h2 className="text-sm lg:text-base">Total Over Time</h2>
                <h2 className="text-base font-bold text-cred">
                  {singleStaffattendanceStatistics?.overtime || "0"} H
                </h2>
              </div>
            </div>
            <div className="bg-cblack3 py-2 px-4 flex gap-5 rounded-md border border-gray-700">
              <div className="space-y-1 text-white">
                <h2 className="text-sm lg:text-base">Absent</h2>
                <h2 className="text-base font-bold text-cred">
                  {singleStaffattendanceStatistics?.absent_days || "0"} Days
                </h2>
              </div>
            </div>
            <div className="bg-cblack3 py-2 px-4 flex gap-5 rounded-md border border-gray-700">
              <div className="space-y-1 text-white">
                <h2 className="text-sm lg:text-base">Late</h2>
                <h2 className="text-base font-bold text-cred">
                  {singleStaffattendanceStatistics?.late || "0"} Days
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-5 justify-between items-end mt-5">
          <div className="flex items-end gap-5">
            <MonthYearSelector
              defaultValue={monthDate}
              onChange={setMonthDate}
            />
          </div>
          <div className="flex gap-3 justify-center items-center">
            <div className="flex gap-1 justify-center items-center">
              <h3 className="text-white">Show</h3>
              <Select
                onValueChange={(value) => setPerPage(Number(value))}
                value={perPage.toString()}
              >
                <SelectTrigger className="w-[60px]">
                  <SelectValue placeholder="10" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="5">5</SelectItem>
                    <SelectItem value="10">10</SelectItem>
                    <SelectItem value="20">20</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <SingleStaffDetailsTable data={singleStaffAttendance} />
        </div>
        <div>
          <Paginat
            pagination={singleStaffPagination}
            onPageChange={(page) => setPage(page)}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default Report;
